"use client";
// @ts-strict-ignore
import styled from "styled-components";
import { motion } from "framer-motion";

export const ContentBox = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  border-radius: 16px;
  padding: 29px 24px 47px 24px;
  flex-direction: column;
  margin: 0px 0px 40px;
  min-height: 190px;

  justify-content: ${(props) =>
    `${props?.sm?.justifyContent || "space-between"}`};

  ${({ theme: { media } }) => media.mobileLandscape`
   justify-content: ${(props) => `${props?.justifyContent || "space-between"}`};
    padding: 0px 24px 0px 24px;
    flex-direction: row;
    margin: 0px 0px 40px;
  `};
  ${({ theme: { media } }) => media.desktop`
  padding: 0px 42px 0px 24px;
 `};
  & * {
    box-sizing: border-box;
  }

  &:after {
    content: "";
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background:
      linear-gradient(190deg, #26ddf9 -30.81%, #00b0cb 73.56%), #676868;
    position: absolute;
    z-index: 2;
    border-radius: 16px;
  }
  h2 {
    position: relative;
    z-index: 5;
  }
  button {
    border-color: transparent;
    min-width: 140px;
    font-size: 14px;
    height: 40px;
    font-weight: 600;
    padding: 0px 21px;
    margin: 0px auto 0px 0px;
    background-color: ${(props) => `${props?.theme.colorPalette.white}`};
    background-color: ${({ theme }) => theme.colorPalette.white};
    &:hover {
      background-color: ${({ theme }) => theme.colorPalette.gray[50]};
    }
    &:active,
    &:focus {
      background-color: ${({ theme }) => theme.colorPalette.gray[100]};
    }
    &:disabled {
      background-color: ${({ theme }) => theme.colorPalette.gray[800]};
      color: ${({ theme }) => theme.colorPalette.gray[600]};
    }
  }
  p {
    max-width: 295px;
    ${({ theme: { media } }) => media.tablet`
    max-width: 350px;
`};
  }
  &.cryptopedia {
    margin-bottom: 8px;
    padding: 29px 24px 23px 24px;
    ${({ theme: { media } }) => media.mobileLandscape`
    margin-bottom: 8px;
`};
    ${({ theme: { media } }) => media.desktop`
    padding: 0px 42px 0px 24px;
`};

    &:after {
      background: ${({ theme }) => theme.colorPalette.pink};
    }
    h2 {
      max-width: 302px;
      color: ${({ theme }) => theme.colorPalette.black};
    }
    p {
      margin-bottom: 12px;
    }
    button {
      color: ${({ theme }) => theme.colorPalette.white};
      background-color: ${({ theme }) => theme.colorPalette.black};
    }
    img {
      position: relative;
      top: 0px;
      margin-top: 10px;
      ${({ theme: { media } }) => media.tablet`
      margin-top: 0px;
      top: 3px;
  `};
    }
    & > div:nth-child(2) {
      & > div {
        align-items: flex-end;
      }
    }
  }
`;

export const ContentRightSideBody = styled.div`
  display: flex;
  position: relative;
  width: auto;
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    margin-top: 29px;
    ${({ theme: { media } }) => media.tablet`
    margin-top: 0px;
`};
  }
`;

export const DownAnimation = styled(motion.div)`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 22;
`;
export const AnimationBoxHeading = styled(motion.div)`
  position: relative;
  z-index: 6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 6px;
`;
